<template>
  <section :id="`uuid-${$attrs.uuid}`" :class="[{'image-half' : checkImageHalf},'section card-small']">
    <div class="card-small-container section__container">
      <div class="section__wrapper">
        <picture class="card-small__picture" ref="cardPicture">
          <div class="card-small__info-container-flex">
            <div class="card-small__info-container">
              <span v-if="cardSmallEventCategory" class="card-small__event-category">{{cardSmallEventCategory.title}}</span>
              <h4 class="card-small__title cta-white" :class="{'event' : cardSmallEventCategory}" ref="cardTitle">{{title}}</h4>
              <div class="card-small__cta-links">
                <advanced-button-wrapper
                  class="card-small-cta-link cta-white"
                  color="primary"
                  styleType="text"
                  size="medium"
                  ref="ctaLink"
                  :cta-obj="ctaLink[0]"
                  :analyticsData="analyticsData(ctaLink)" />
              </div>
            </div>
          </div>
          <source
              media="(min-width:0) and (max-width:640px)"
              :srcset="cardSmallImgMobile | mgnlMedia('url')"
              v-if="cardSmallImgMobile"
          />
          <source
              media="(min-width:0) and (max-width:640px)"
              :srcset="cardSmallImgDesktop | mgnlMedia('url')"
              v-else-if="!cardSmallImgMobile"
          />
          <source
              v-else
              media="(min-width:641px)"
              :srcset="cardSmallImgDesktop | mgnlMedia('url')"
          />
          <pg-image
              :lazy-src="isMobileImage | mgnlMedia('url')"
              :alt="imageAlt"
              ref="cardImage"
          />
          <div class="card-small__gradient" :class="{'disabled' : disableGradient }" ref="cardGradient"></div>
        </picture>
      </div>
    </div>
  </section>
</template>

<script>
import PgImage from "../Image/Image.vue";
import advancedButtonWrapper from "../Advanced-Button-Wrapper/Advanced-Button-Wrapper";
import {mgnlComponentMixin} from "@wl-vue-mixins/mixins";

export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
  name: "cardSmall",

  components: {
    advancedButtonWrapper,
    PgImage
  },

  props: {
    disableGradient : {
      type: Boolean
    },
    ctaLink: {
      type: Array,
      default: () => []
    },
    cardSmallEventCategory: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    cardSmallImgDesktop: {
      type: Object,
      default: () => {}
    },
    cardSmallImgMobile: {
      type: Object,
      default: () => {}
    },
    checkImageHalf: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    isMobile() {
      return window.matchMedia('only screen and (max-width: 1200px)').matches;
    },
    isMobileImage() {
      return this.isMobile && this.cardSmallImgMobile ? this.cardSmallImgMobile : this.cardSmallImgDesktop;
    },
    imageAlt() {
      return this.isMobile && this.cardSmallImgMobile ? this.cardSmallImgMobile.title : this.cardSmallImgDesktop.title;
    },
  },

  mounted() {
    this.checkImageHalf && this.isImageHalf();
  },

  methods: {
    isImageHalf() {
      const imageElement = this.$refs.cardImage.$el;
      const gradient = this.$refs.cardGradient;
      const marginValue = "calc(345px / 2)";
      const heightValue = "auto";
      imageElement.addEventListener("load", () => {
        //remove gradient if is card with half image
        gradient.parentNode.removeChild(gradient);
        imageElement.style.marginTop = marginValue;
        imageElement.style.height = heightValue;
      });
      if (this.$refs.ctaLink.$el.classList) this.$refs.ctaLink.$el.classList.remove("cta-white");
      this.$refs.cardTitle.classList.remove("cta-white");
    },
    analyticsData(el) {
      return {
        evCategory: 'card_big',
        evAction: el.document?.url || el.link?.url || el.trackingLabel,
        evLabel: `${el.campaignId || 'No Campaign'} | ${this.common.actpageFullUrl}`
      }
    }
  }
}

</script>